import { AppRouteProps } from "@harea/component";
import React from "react";
const GroupsCreateContainer = React.lazy(() => import("./container/GroupsCreateContainer"));

export const GroupsCreateRoutes: Array<AppRouteProps> = [
    {
        path: "create",
        title: "BSM.UserManagement.Groups.Create.Title",
        hideBreadcrumb: true,
        element: <GroupsCreateContainer />,
    },
    {
        path: ":groupId/edit",
        title: "BSM.UserManagement.Groups.Edit.Title",
        hideBreadcrumb: true,
        element: <GroupsCreateContainer />,
    },
];
